module.exports = "<div class=\"modal-content\" ng-controller=\"ProgressModalCtrl\">\n    <div class=\"modal-body\">\n        <progress-bar-round>\n        </progress-bar-round>\n    </div>\n    <div class=\"modal-footer\">\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/app/pages/ui/modals/progressModal/progressModal.html
// module id = 832
// module chunks = 2